import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { insertUpdateAgencyRentalAvEquipment_action } from "../../../../../actions/admin_module_action/master_action/manual_form_master_action/rental_audio_video_master_action";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { emailValidator } from "../../../../../utils/Validator";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import Footer from "../../../../../common_components/Footer";

class RentalAudioVideoMasterAU extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            editID: null,
            // Agency Contact
            AgencyName: '',
            AgencyAddress: '',
            Telephone: '',
            MobileNo: '',
            Fax: '',
            AgencyEmailPrimary: '',
            AgencyEmailSecondary: '',
            // Bank Details
            BankName: '',
            BankAddress: '',
            AccountNo: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            SwiftCode: '',
            IFSC: '',
            PanNo: '',
            GST: '',
            // Errors
            AgencyNameErr: '',
            MobileNoErr: '',
            AgencyEmailPrimaryErr: '',
            AgencyEmailSecondaryErr: '',
        }
        this.handleSave = this.handleSave.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        const locState = this.props.location.state
        const editData = locState && locState.editData ? locState.editData : null
        if (editData) {
            this.setState({
                editID: editData.AgencyRentalAvEquipmentID || null,
                AgencyName: editData.AgencyName || '',
                AgencyAddress: editData.AgencyAddress || '',
                Telephone: editData.Telephone || '',
                MobileNo: editData.MobileNo || '',
                Fax: editData.Fax || '',
                AgencyEmailPrimary: editData.AgencyEmailPrimary || '',
                AgencyEmailSecondary: editData.AgencyEmailSecondary || '',
                BankName: editData.BankName || '',
                BankAddress: editData.BankAddress || '',
                AccountNo: editData.AccountNo || '',
                BeneficiaryName: editData.BeneficiaryName || '',
                BeneficiaryAddress: editData.BeneficiaryAddress || '',
                SwiftCode: editData.SwiftCode || '',
                IFSC: editData.IFSC || '',
                PanNo: editData.PanNo || '',
                GST: editData.GST || '',
            })
        }
    }

    validate() {
        const { AgencyName, MobileNo, AgencyEmailPrimary, AgencyEmailSecondary } = this.state
        let valid = true
        if (!AgencyName) {
            this.setState({ AgencyNameErr: 'Please enter Agency Name' })
            valid = false
        }
        if (!MobileNo) {
            this.setState({ MobileNoErr: 'Please enter Mobile No.' })
            valid = false
        }
        if (!AgencyEmailPrimary) {
            this.setState({ AgencyEmailPrimaryErr: 'Please enter Primary Email' })
            valid = false
        } else {
            const err = emailValidator(AgencyEmailPrimary)
            if (err) {
                this.setState({ AgencyEmailPrimaryErr: 'Please enter a valid Primary Email' })
                valid = false
            }
        }
        if (AgencyEmailSecondary) {
            const err = emailValidator(AgencyEmailSecondary)
            if (err) {
                this.setState({ AgencyEmailSecondaryErr: 'Please enter a valid Secondary Email' })
                valid = false
            }
        }
        return valid
    }

    handleSave() {
        const {
            editID, AgencyName, AgencyAddress, Telephone, MobileNo, Fax,
            AgencyEmailPrimary, AgencyEmailSecondary,
            BankName, BankAddress, AccountNo, BeneficiaryName, BeneficiaryAddress,
            SwiftCode, IFSC, PanNo, GST,
        } = this.state

        if (!this.validate()) {
            toastError('Please enter mandatory fields')
            return
        }

        this.setState({ isLoading: true })
        this.props.insertUpdateAgencyRentalAvEquipment_action({
            AgencyRentalAvEquipmentID: editID || 0,
            AgencyName,
            AgencyAddress,
            Telephone,
            MobileNo,
            Fax,
            AgencyEmailPrimary,
            AgencyEmailSecondary,
            BankName,
            BankAddress,
            AccountNo,
            BeneficiaryName,
            BeneficiaryAddress,
            SwiftCode,
            IFSC,
            PanNo,
            GST,
            AgencyRentalAudioVideoImage: '',
        })
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess('Record saved successfully')
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.props.navigate('/rentalAudioVideoMaster')
                    }, 300)
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    handleCancel() {
        this.props.navigate('/rentalAudioVideoMaster')
    }

    render() {
        const {
            isLoading,
            AgencyName, AgencyAddress, Telephone, MobileNo, Fax,
            AgencyEmailPrimary, AgencyEmailSecondary,
            BankName, BankAddress, AccountNo, BeneficiaryName, BeneficiaryAddress,
            SwiftCode, IFSC, PanNo, GST,
            AgencyNameErr, MobileNoErr, AgencyEmailPrimaryErr, AgencyEmailSecondaryErr,
        } = this.state

        return (
            <>
                {isLoading ? <Loader /> : null}
                <ToastContainer />
                <HeaderWithLogo />
                <div className="app-content with-dr-container com-height">
                    <AdminDrawer />
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Rental Audio Video Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 pt-0">

                            {/* Agency Contact */}
                            <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                <h3 className="card-title" style={{ fontSize: 15 }}>Agency Contact</h3>
                            </div>
                            <div className="card-body p-2 mt-1">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label>Name<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AgencyName}
                                            onChange={(e) => this.setState({ AgencyName: e.target.value, AgencyNameErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{AgencyNameErr}</span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Mobile No.<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={MobileNo}
                                            onChange={(e) => this.setState({ MobileNo: e.target.value, MobileNoErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{MobileNoErr}</span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AgencyAddress}
                                            onChange={(e) => this.setState({ AgencyAddress: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-xl-3">
                                        <label>Telephone</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={Telephone}
                                            onChange={(e) => this.setState({ Telephone: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Fax</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={Fax}
                                            onChange={(e) => this.setState({ Fax: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Primary Email<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AgencyEmailPrimary}
                                            onChange={(e) => this.setState({ AgencyEmailPrimary: e.target.value, AgencyEmailPrimaryErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{AgencyEmailPrimaryErr}</span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Secondary Email</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AgencyEmailSecondary}
                                            onChange={(e) => this.setState({ AgencyEmailSecondary: e.target.value, AgencyEmailSecondaryErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{AgencyEmailSecondaryErr}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Bank Details */}
                            <div className="card-header p-2 mt-3" style={{ paddingLeft: "7px !important" }}>
                                <h3 className="card-title" style={{ fontSize: 15 }}>Bank Details</h3>
                            </div>
                            <div className="card-body p-2 mt-1">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label>Bank Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BankName}
                                            onChange={(e) => this.setState({ BankName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-6">
                                        <label>Bank Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BankAddress}
                                            onChange={(e) => this.setState({ BankAddress: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Account No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AccountNo}
                                            onChange={(e) => this.setState({ AccountNo: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3 mt-2">
                                        <label>Beneficiary Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BeneficiaryName}
                                            onChange={(e) => this.setState({ BeneficiaryName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-6 mt-2">
                                        <label>Beneficiary Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BeneficiaryAddress}
                                            onChange={(e) => this.setState({ BeneficiaryAddress: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3 mt-2">
                                        <label>Swift Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={SwiftCode}
                                            onChange={(e) => this.setState({ SwiftCode: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-xl-3">
                                        <label>IFSC Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={IFSC}
                                            onChange={(e) => this.setState({ IFSC: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>PAN No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={PanNo}
                                            onChange={(e) => this.setState({ PanNo: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>GST Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={GST}
                                            onChange={(e) => this.setState({ GST: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="save-can d-block text-end" role="group">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        onClick={this.handleSave}
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-back ms-2"
                                        onClick={this.handleCancel}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { insertUpdateAgencyRentalAvEquipment_action })(RentalAudioVideoMasterAU));
